import request from "request-promise";
import { RequestOptionsService } from "./requestOptions";

export class KioskConfigurationService {
  public static async UpdateSetting(field: string, data: any) {
    const options = RequestOptionsService.postBrearerOptions(`KioskConfiguration/UpdateSetting`, {
      key: field,
      value: data
    });
    await request(options);
  }
}
